export const SET_LOCATION_FILTERS_FULFILLED = 'SET_LOCATION_FILTERS_FULFILLED';
export const SET_PRICE_FILTERS_FULFILLED = 'SET_PRICE_FILTERS_FULFILLED';
export const SET_ROOM_COUNT_FILTERS_FULFILLED = 'SET_ROOM_COUNT_FILTERS_FULFILLED';
export const CLEAR_ALL_FILTERS_FULFILLED = 'CLEAR_ALL_FILTERS_FULFILLED';
